import { render } from "./Label.vue?vue&type=template&id=421ee3b3&scoped=true"
const script = {}

import "./Label.vue?vue&type=style&index=0&id=421ee3b3&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-421ee3b3"

export default script